const GOOGLE_MAP_API_KEY = 'AIzaSyBEPAkh2NlU4LSfqi5GxJZYz-saLmk0obs';
export default GOOGLE_MAP_API_KEY;
